import h from "../core/createElement";

export default function EmptyMsgBox({ text = "" }) {
    return (
        <section class="empty-box">
            <span>{text}</span>
        </section>
    );
};